export default __webpack_public_path__ + "static/hover_measurements-95096c0ecb1a1d6d8705cd4e31669881.mp4";